// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1___5efbbea0513a6863ffc","cls2":"Timer-cls2___60b8fff004c94732c37 Timer-cls1___5efbbea0513a6863ffc"};